import {
  DashboardActions,
  InternalProjectActions,
} from '@store/reducers/dashboard/actions'
import { all, takeEvery } from 'redux-saga/effects'

import { archive } from './archive'
import { create } from './create'
import { created } from './created'
import { deleteSaga } from './delete'
import { duplicate } from './duplicate'
import { internalMove } from './internalMove'
import { leave } from './leave'
import { moveTo } from './moveTo'
import { pin, unpin } from './pin'
import { share } from './share'
import { unarchive } from './unarchive'

export function* projectsSaga() {
  yield all([
    takeEvery(InternalProjectActions.move, internalMove),
    takeEvery(DashboardActions.projects.moveToWorkspace, moveTo),
    takeEvery(DashboardActions.projects.delete, deleteSaga),
    takeEvery(DashboardActions.projects.leave, leave),
    takeEvery(DashboardActions.projects.archive, archive),
    takeEvery(DashboardActions.projects.unarchive, unarchive),
    takeEvery(DashboardActions.projects.pin, pin),
    takeEvery(DashboardActions.projects.unpin, unpin),
    takeEvery(DashboardActions.projects.duplicate, duplicate),
    takeEvery(DashboardActions.projects.share, share),
    takeEvery(DashboardActions.projects.create, create),
    takeEvery(DashboardActions.projects.created, created),
  ])
}
